import React from "react";

interface AboutUsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AboutUsModal: React.FC<AboutUsModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      <div className="bg-white rounded-mediumRound shadow-lg max-w-4xl w-full mx-4 p-8 relative max-h-[90vh] overflow-hidden">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 z-10"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        {/* Content with scroll */}
        <div className="max-h-[80vh] overflow-y-auto pr-4">
          <div className="mb-6">
            <h1 className="text-2xl font-bold text-primary mb-3">About Us</h1>
          </div>
          <div className="space-y-6 text-base text-gray-700 leading-relaxed">
            <section>
              <p>
                <b>DroneDen</b> is the first marketplace in Romania—and one of the very few in Europe—built exclusively for connecting people and businesses with licensed drone pilots.
              </p>
              <p>
                We started DroneDen because finding a reliable pilot for aerial photos, videos or mapping jobs was harder than it should be. Scattered social media groups, endless phone calls, uncertain licences—there had to be a better way. Our team created a platform where:
              </p>
              <ul className="ml-6 mb-2 list-disc space-y-1">
                <li>
                  <strong>Clients</strong> can discover verified professionals in seconds, compare portfolios and book with escrow-protected payments.
                </li>
                <li>
                  <strong>Pilots</strong> can showcase their skills, get hired on merit and focus on flying instead of chasing invoices.
                </li>
              </ul>
              <p>
                From cinematic real-estate shots to 3D construction surveys, we believe high-quality aerial imagery should be easy, transparent and safe to source. That’s why every mission on DroneDen is backed by licence checks, secure Stripe payouts and a clear 20% service fee that keeps the marketplace running.
              </p>
              <p>
                Whether you’re launching a roof inspection at dawn or filming a festival at sunset, DroneDen is here to lift your project off the ground—one flight at a time.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUsModal;